import { ThresholdsResourceScope } from '../models/commonEnums';
import { SpaceThresholds } from '../models/customThresholdModels';

/**
 * Extracts threshold boundary values from API SpaceThresholds in ascending order.
 * Use this so the graph/summary page uses the same values as the settings page (thresholds API).
 */
export default function getThresholdValuesFromSpaceThresholds(
    spaceThresholds: SpaceThresholds,
    scope: ThresholdsResourceScope
): number[] {
    const options = spaceThresholds.thresholdOptions?.options?.[scope];
    if (!options?.length) return [];
    return options.map(opt => opt.value).sort((a, b) => a - b);
}
